<template>
  <div
    class="menu noprint"
    :class="{ collapsed: isCollapsed }"
    v-if="props.type == 'left'"
  >
    <div
      class="flex flex-column justify-content-between align-content-between h-full w-full"
    >
      <div class="flex flex-column buttonspace">
        <div v-if="!screen.isMobile" class="menu-toggle-row" :class="{ collapsed }">
          <button
            class="menu-toggle"
            data-e2e="menu-toggle-collapse"
            @click="collapsed = !collapsed"
            :title="collapsed ? 'Expandir menú' : 'Contraer menú'"
          >
            <i :class="collapsed ? 'pi pi-angle-double-right' : 'pi pi-angle-double-left'"></i>
          </button>
        </div>

        <template v-for="group in topMenuGroups" :key="group.key">
          <div v-if="!isCollapsed" class="menu-section-title">{{ group.label }}</div>
          <button
            v-for="item in group.items"
            :key="item.key"
            :data-e2e="item.testId"
            class="p-button-secondary"
            @click="route.$patch({ page: item.page })"
            v-tooltip.right="isCollapsed ? item.label : null"
            :class="{ active: route.page == item.page }"
          >
            <div class="flex align-items-center w-full">
              <i :class="item.icon"></i>
              <span>{{ item.label }}</span>
            </div>
            <div class="text-xs" v-if="item.subtitle">{{ item.subtitle }}</div>
          </button>
        </template>

        <!-- Indicador de usuarios en línea -->
        <div
          v-if="onlineCount > 0"
          class="online-indicator"
          v-tooltip.right="isCollapsed ? `${onlineCount} usuario${onlineCount > 1 ? 's' : ''} en línea` : null"
        >
          <span class="online-dot" />
          <span class="text-xs">{{ onlineCount }} usuario{{ onlineCount > 1 ? 's' : '' }} en línea</span>
        </div>

        <button
          class="p-button-secondary"
          label="Modo oscuro"
          data-e2e="menu-theme-toggle"
          @click="themeStore.toggle()"
          v-tooltip.right="isCollapsed ? (themeStore.theme === 'dark' ? 'Modo claro' : 'Modo oscuro') : null"
        >
          <div class="flex align-items-center w-full">
            <i :class="themeStore.theme === 'dark' ? 'pi pi-sun' : 'pi pi-moon'"></i>
            <span>{{ themeStore.theme === 'dark' ? 'Modo claro' : 'Modo oscuro' }}</span>
          </div>
        </button>

        <button
          class="p-button-secondary"
          label="Configuraciones"
          data-e2e="menu-configuracion"
          @click="route.$patch({ page: 'parametros' })"
          v-tooltip.right="isCollapsed ? 'Configuración' : null"
          :class="{
            active:
              route.page == 'downloadTerritorio' || route.page == 'parametros',
          }"
        >
          <div class="flex align-items-center w-full">
            <i class="pi pi-cog"></i>
            <span>Configuración</span>
          </div>
        </button>

        <button
          class="p-button-secondary"
          label="Ayuda"
          data-e2e="menu-ayuda"
          @click="showHelp = true"
          v-tooltip.right="isCollapsed ? 'Ayuda' : null"
        >
          <div class="flex align-items-center w-full">
            <i class="pi pi-question-circle"></i>
            <span>Ayuda</span>
          </div>
        </button>

        <button
          label="Cerrar Sesion"
          class="p-button-warning"
          @click="confirm1"
          v-tooltip.right="isCollapsed ? 'Cerrar sesión' : null"
        >
          <div class="flex align-items-center w-full">
            <i class="pi pi-power-off"></i>
            <span>Cerrar Sesion</span>
          </div>
        </button>

        <a
          v-if="!isCollapsed"
          href="/legal"
          target="_blank"
          rel="noopener noreferrer"
          class="menu-legal-link"
        >Términos, privacidad y uso de datos</a>
      </div>
    </div>
  </div>

  <!-- Menú superior (escritorio): grupos con submenú desplegable -->
  <div v-if="props.type == 'top-desktop'" ref="topMenuRef" class="menu-top noprint">
    <div class="menu-top-row">
      <div v-for="group in topMenuGroups" :key="group.key" class="menu-top-group">
        <button
          class="menu-top-btn"
          :class="{ active: isGroupActive(group), open: openGroup === group.key }"
          @click="toggleGroup(group.key)"
        >
          <i :class="group.icon"></i>
          <span>{{ group.label }}</span>
          <i class="pi pi-angle-down caret"></i>
        </button>
        <div v-if="openGroup === group.key" class="menu-top-dropdown">
          <button
            v-for="item in group.items"
            :key="item.key"
            class="menu-top-dropdown-item"
            :class="{ active: route.page == item.page }"
            @click="selectPage(item.page)"
          >
            <i :class="item.icon"></i>
            <div class="menu-top-dropdown-text">
              <span>{{ item.label }}</span>
              <div class="text-xs" v-if="item.subtitle">{{ item.subtitle }}</div>
            </div>
          </button>
        </div>
      </div>

      <div class="menu-top-spacer" />

      <div v-if="onlineCount > 0" class="online-indicator online-indicator-top">
        <span class="online-dot" />
        <span class="text-xs">{{ onlineCount }} usuario{{ onlineCount > 1 ? 's' : '' }} en línea</span>
      </div>

      <button class="menu-top-btn" @click="themeStore.toggle()">
        <i :class="themeStore.theme === 'dark' ? 'pi pi-sun' : 'pi pi-moon'"></i>
        <span>{{ themeStore.theme === 'dark' ? 'Modo claro' : 'Modo oscuro' }}</span>
      </button>

      <button
        class="menu-top-btn"
        :class="{ active: route.page == 'downloadTerritorio' || route.page == 'parametros' }"
        @click="selectPage('parametros')"
      >
        <i class="pi pi-cog"></i>
        <span>Configuración</span>
      </button>

      <button class="menu-top-btn" data-e2e="menu-ayuda" @click="showHelp = true">
        <i class="pi pi-question-circle"></i>
        <span>Ayuda</span>
      </button>

      <button class="menu-top-btn menu-top-danger" @click="confirm1">
        <i class="pi pi-power-off"></i>
        <span>Cerrar Sesion</span>
      </button>

      <a href="/legal" target="_blank" rel="noopener noreferrer" class="menu-top-legal-link">
        Legal
      </a>
    </div>
  </div>

  <div
    v-if="props.type == 'top'"
    class="topbar w-full flex align-items-center justify-content-between noprint"
  >
    <Button
      icon="pi pi-bars"
      text
      rounded
      severity="secondary"
      @click="screen.showSidebar = !screen.showSidebar"
    />
    <div class="topbar-title">
      {{ title[route.page] }}
    </div>
    <div class="flex align-items-center">
      <Button
        icon="pi pi-question-circle"
        text
        rounded
        severity="secondary"
        data-e2e="menu-ayuda-mobile"
        @click="showHelp = true"
      />
      <Button
        :icon="themeStore.theme === 'dark' ? 'pi pi-sun' : 'pi pi-moon'"
        text
        rounded
        severity="secondary"
        data-e2e="menu-theme-toggle-mobile"
        @click="themeStore.toggle()"
      />
    </div>
  </div>

  <HelpModal v-model:visible="showHelp" />
</template>

<script setup>
import { computed, ref, watch, onMounted, onBeforeUnmount, defineProps } from "vue";
import { useRouterStore } from "@/store/router";
import { useConfirm } from "primevue/useconfirm";
import { useUserStore } from "@/store/useUserStore";
import { useMenuConfigStore } from "@/store/useMenuConfigStore";
import { usePresenceStore } from "@/store/usePresenceStore";
import { useScreenStore } from "@/store/useScreenStore";
import { useThemeStore } from "@/store/useThemeStore";
import HelpModal from "@/components/Help/HelpModal.vue";
const screen = useScreenStore();
const themeStore = useThemeStore();

const showHelp = ref(false);

const props = defineProps({
  type: {
    type: String,
    default: "left",
  },
});

const userStore = useUserStore();
const menuConfig = useMenuConfigStore();
const route = useRouterStore();
const confirm = useConfirm();
const presenceStore = usePresenceStore();

// Menú lateral colapsable (solo escritorio) — se recuerda entre sesiones.
const COLLAPSE_KEY = "menuCollapsed";
const collapsed = ref(localStorage.getItem(COLLAPSE_KEY) === "1");
const isCollapsed = computed(() => collapsed.value && !screen.isMobile);
watch(collapsed, (value) => {
  localStorage.setItem(COLLAPSE_KEY, value ? "1" : "0");
});

const onlineCount = computed(() =>
  presenceStore.users.filter((u) => u.uid !== userStore.uid).length
);

// Menú superior (escritorio): ítems agrupados con submenú desplegable.
const topMenuRef = ref(null);
const openGroup = ref(null);

const toggleGroup = (key) => {
  openGroup.value = openGroup.value === key ? null : key;
};

const selectPage = (page) => {
  route.$patch({ page });
  openGroup.value = null;
};

const isGroupActive = (group) => group.items.some((item) => item.page === route.page);

const topMenuGroups = computed(() =>
  [
    {
      key: "territorios",
      label: "Territorios",
      icon: "pi pi-sitemap",
      items: [
        menuConfig.isEnabled("listaTerritorio") && { key: "listaTerritorio", label: "Territorios", subtitle: "Modifica territorios", icon: "pi pi-sitemap", page: "listaTerritorio", testId: "menu-territorios" },
        menuConfig.isEnabled("tAsignados") && { key: "tAsignados", label: "Asignados", subtitle: "Territorios asignados", icon: "pi pi-bookmark", page: "tAsignados", testId: "menu-asignados" },
        menuConfig.isEnabled("mapaCalor") && { key: "mapaCalor", label: "Mapa de calor", subtitle: "Manzanas trabajadas", icon: "pi pi-th-large", page: "mapaCalor", testId: "menu-mapa-calor" },
        menuConfig.isEnabled("rutas") && { key: "rutas", label: "Rutas", subtitle: "Rutas prediseñadas", icon: "pi pi-directions", page: "rutas", testId: "menu-rutas" },
        menuConfig.isEnabled("mapaTerritorios") && { key: "mapaTerritorios", label: "Mapa", subtitle: "Visualiza territorios", icon: "pi pi-map", page: "mapaTerritorios", testId: "menu-mapa" },
        menuConfig.isEnabled("estadisticas") && { key: "estadisticas", label: "Informe S-13", subtitle: "Genera informes", icon: "pi pi-chart-line", page: "estadisticas", testId: "menu-estadisticas" },
      ].filter(Boolean),
    },
    {
      key: "salidas",
      label: "Salidas",
      icon: "pi pi-briefcase",
      items: [
        menuConfig.isEnabled("salidas") && { key: "salidas", label: "Salidas", subtitle: "Crear salidas", icon: "pi pi-briefcase", page: "salidas", testId: "menu-salidas" },
        menuConfig.isEnabled("enlacesSalidas") && { key: "enlacesSalidas", label: "Enlaces", subtitle: "Acceso público", icon: "pi pi-link", page: "enlacesSalidas" },
        menuConfig.isEnabled("enlacesInformes") && { key: "enlacesInformes", label: "Informes", subtitle: "Enlaces para conductores", icon: "pi pi-check-square", page: "enlacesInformes" },
        menuConfig.isEnabled("transporteTerritorio") && { key: "transporteTerritorio", label: "Transporte", subtitle: "Líneas de transporte", icon: "pi pi-car", page: "transporteTerritorio" },
        menuConfig.isEnabled("alojamientos") && { key: "alojamientos", label: "Alojamientos", subtitle: "Dónde se hospedan", icon: "pi pi-home", page: "alojamientos" },
        menuConfig.isEnabled("gruposInvitados") && { key: "gruposInvitados", label: "Invitados", subtitle: "Grupos de invitados", icon: "pi pi-users", page: "gruposInvitados" },
      ].filter(Boolean),
    },
    {
      key: "estudios",
      label: "Estudios",
      icon: "pi pi-book",
      items: [
        menuConfig.isEnabled("estudiosTerritorio") && { key: "estudiosTerritorio", label: "Estudios", subtitle: "Estudios iniciados", icon: "pi pi-book", page: "estudiosTerritorio" },
        menuConfig.isEnabled("estudiosTerritorio") && menuConfig.isEnabled("estudiosDashboard") && { key: "estudiosDashboard", label: "Enlaces de estudios", subtitle: "Comparte estudios seleccionados", icon: "pi pi-share-alt", page: "estudiosDashboard" },
      ].filter(Boolean),
    },
    {
      key: "administracion",
      label: "Administración",
      icon: "pi pi-shield",
      items: [
        (userStore.isAdmin && userStore.hasCongregation && !userStore.isSuperUser && menuConfig.isEnabled("userManagement")) &&
          { key: "userManagement", label: "Usuarios", subtitle: "Gestionar miembros", icon: "pi pi-users", page: "userManagement" },
        userStore.isSuperUser && { key: "adminPanel", label: "Admin", subtitle: "Congregaciones", icon: "pi pi-shield", page: "adminPanel" },
        menuConfig.isEnabled("plantillasMensaje") && { key: "plantillasMensaje", label: "Plantillas", subtitle: "Mensajes de WhatsApp", icon: "pi pi-comment", page: "plantillasMensaje" },
        menuConfig.isEnabled("metadataEnlaces") && { key: "metadataEnlaces", label: "Metadata", subtitle: "Preview de los enlaces", icon: "pi pi-share-alt", page: "metadataEnlaces" },
      ].filter(Boolean),
    },
  ].filter((group) => group.items.length > 0)
);

watch(
  () => route.page,
  () => {
    openGroup.value = null;
  }
);

const handleOutsideClick = (event) => {
  if (openGroup.value && topMenuRef.value && !topMenuRef.value.contains(event.target)) {
    openGroup.value = null;
  }
};

onMounted(() => document.addEventListener("mousedown", handleOutsideClick));
onBeforeUnmount(() => document.removeEventListener("mousedown", handleOutsideClick));

const logout = async () => {
  presenceStore.disconnect();
  userStore.clearUser();
  location.reload();
};

// route.page == 'mapaTerritorios' 
const title = {
  "mapaTerritorios": "Mapa de territorio",
  "mapaCalor": "Mapa de calor",
  "salidas": "Salidas",
  "listaTerritorio": "Territorios",
  "estadisticas": "Informe S-13",
  "rutas": "Rutas",
  "tAsignados": "Territorios asignados",
  "parametros": "Configuración",
  "userManagement": "Gestión de Usuarios",
  "adminPanel": "Panel de Administración",
  "gruposInvitados": "Grupos de invitados",
  "plantillasMensaje": "Plantillas de mensaje",
  "metadataEnlaces": "Metadata de enlaces",
  "alojamientos": "Alojamientos",
  "estudiosTerritorio": "Estudios iniciados",
  "transporteTerritorio": "Transporte",
  "enlacesSalidas": "Enlaces de acceso",
  "enlacesInformes": "Informes de conductores",
  "estudiosDashboard": "Enlaces de estudios",
}

const confirm1 = (event) => {
  confirm.require({
    target: event.currentTarget,
    message: "¿Desea cerrar sesión?",
    icon: "pi pi-exclamation-triangle",
    rejectClass: "p-button-secondary p-button-outlined p-button-sm",
    acceptClass: "p-button-sm",
    rejectLabel: "No",
    acceptLabel: "Sí",
    accept: () => {
      logout();
    },
  });
};
</script>

<style scoped>
.menu {
  width: 248px;
  background: var(--bg-secondary);
  border-right: 1px solid var(--separator);
  padding: var(--space-3);
  display: flex;
  gap: var(--space-2);
  transition: width var(--duration-base) var(--ease-standard);
}

.menu.collapsed {
  width: 72px;
  padding: var(--space-3) var(--space-2);
}

.buttonspace {
  gap: 2px;
}

/* Encabezado de sección del menú lateral (agrupa por categoría) */
.menu-section-title {
  padding: var(--space-2) var(--space-3) 2px;
  margin-top: var(--space-2);
  font-size: var(--text-caption);
  font-weight: var(--weight-semibold);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--label-tertiary, var(--label-secondary));
}
.menu-section-title:first-child {
  margin-top: 0;
}

/* Botón para contraer/expandir el menú */
.menu-toggle-row {
  display: flex;
  justify-content: flex-end;
  margin-bottom: var(--space-1);
}
.menu-toggle-row.collapsed {
  justify-content: center;
}

.menu-toggle {
  background: transparent;
  border: none;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: var(--radius-md);
  color: var(--label-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color var(--duration-fast) var(--ease-standard);
}
.menu-toggle:hover {
  background: var(--fill-quaternary);
}

/* Modo colapsado: solo iconos centrados, sin texto */
.menu.collapsed button {
  align-items: center;
  padding: var(--space-2);
}
.menu.collapsed button > div {
  justify-content: center;
}
.menu.collapsed button > div > span,
.menu.collapsed button > .text-xs {
  display: none;
}
.menu.collapsed .online-indicator {
  justify-content: center;
  padding: var(--space-2);
}
.menu.collapsed .online-indicator span:not(.online-dot) {
  display: none;
}

/* Ítem de navegación estilo lista iOS */
.menu button {
  width: 100%;
  padding: var(--space-2) var(--space-3);
  border-radius: var(--radius-md);
  background: transparent;
  color: var(--label-primary);
  border: none;
  cursor: pointer;
  transition: background-color var(--duration-fast) var(--ease-standard),
    color var(--duration-fast) var(--ease-standard);
  display: flex;
  flex-direction: column;
  gap: 1px;
  text-align: left;
}

.menu button > div {
  display: flex;
  align-items: center;
  gap: var(--space-3);
}

.menu button > div > span {
  font-size: var(--text-callout);
  font-weight: var(--weight-semibold);
}

/* Subtítulo (.text-xs) alineado bajo el texto, no bajo el icono */
.menu button > .text-xs {
  padding-left: 30px;
  color: var(--label-secondary);
  font-size: var(--text-caption);
}

.menu button i {
  font-size: 1.05rem;
  display: inline-block;
  width: 18px;
  text-align: center;
  color: var(--label-secondary);
  transition: color var(--duration-fast) var(--ease-standard);
}

.menu button:hover {
  background: var(--fill-quaternary);
}

.menu button.active {
  background: var(--accent-soft);
  color: var(--accent);
}
.menu button.active i,
.menu button.active > .text-xs {
  color: var(--accent);
}

/* Botón cerrar sesión */
.menu button.p-button-warning {
  margin-top: var(--space-3);
  color: var(--danger);
}
.menu button.p-button-warning i {
  color: var(--danger);
}
.menu button.p-button-warning:hover {
  background: var(--danger-soft);
}

/* Link de términos, privacidad y uso de datos */
.menu-legal-link {
  display: block;
  margin-top: var(--space-3);
  padding: var(--space-2) var(--space-3);
  font-size: var(--text-caption-1, 11px);
  color: var(--label-tertiary);
  text-decoration: none;
  text-align: center;
}
.menu-legal-link:hover {
  text-decoration: underline;
}

/* Indicador de usuarios en línea */
.online-indicator {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-3);
  background: var(--success-soft);
  border-radius: var(--radius-md);
  color: var(--success);
  font-weight: var(--weight-medium);
  margin: var(--space-2) 0;
}

.online-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--success);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}

/* Menú superior (escritorio): barra horizontal con submenús desplegables */
.menu-top {
  width: 100%;
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--separator);
  padding: var(--space-2) var(--space-3);
  position: sticky;
  top: 0;
  /* Por encima de los paneles/controles de Leaflet, que usan z-index hasta 1000. */
  z-index: 1100;
}

.menu-top-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-1);
}

.menu-top-group {
  position: relative;
}

.menu-top-spacer {
  flex: 1 1 auto;
}

.menu-top-btn {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-3);
  border-radius: var(--radius-md);
  background: transparent;
  color: var(--label-primary);
  border: none;
  cursor: pointer;
  white-space: nowrap;
  font-size: var(--text-callout);
  font-weight: var(--weight-semibold);
  transition: background-color var(--duration-fast) var(--ease-standard),
    color var(--duration-fast) var(--ease-standard);
}

.menu-top-btn i {
  font-size: 1.05rem;
  color: var(--label-secondary);
  transition: color var(--duration-fast) var(--ease-standard);
}

.menu-top-btn .caret {
  font-size: 0.7rem;
  margin-left: -2px;
  transition: transform var(--duration-fast) var(--ease-standard), color var(--duration-fast) var(--ease-standard);
}

.menu-top-btn.open .caret {
  transform: rotate(180deg);
  margin-left: auto;
}

/* El panel desplegable mide 240px (min-width); el botón debe igualarlo al
   abrirse para que el resaltado cubra todo el ancho del bloque, no solo
   la porción angosta del label. El caret se separa con margin-left: auto
   (no justify-content) para no abrir hueco entre el ícono y el label. */
.menu-top-btn.open {
  min-width: 240px;
}

.menu-top-btn:hover {
  background: var(--fill-quaternary);
}

.menu-top-btn.active,
.menu-top-btn.open {
  background: var(--accent-soft);
  color: var(--accent);
}
.menu-top-btn.active i,
.menu-top-btn.open i {
  color: var(--accent);
}

.menu-top-btn.menu-top-danger {
  color: var(--danger);
}
.menu-top-btn.menu-top-danger i {
  color: var(--danger);
}
.menu-top-btn.menu-top-danger:hover {
  background: var(--danger-soft);
}

.menu-top-legal-link {
  padding: 0 var(--space-3);
  font-size: var(--text-caption-1, 11px);
  color: var(--label-tertiary);
  text-decoration: none;
  white-space: nowrap;
}
.menu-top-legal-link:hover {
  text-decoration: underline;
}

.menu-top-dropdown {
  position: absolute;
  top: calc(100% + var(--space-1));
  left: 0;
  min-width: 240px;
  background: var(--bg-primary);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-3);
  padding: var(--space-2);
  display: flex;
  flex-direction: column;
  gap: 1px;
  z-index: 1101;
}

.menu-top-dropdown-item {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  width: 100%;
  padding: var(--space-2) var(--space-3);
  border-radius: var(--radius-md);
  background: transparent;
  color: var(--label-primary);
  border: none;
  cursor: pointer;
  text-align: left;
  transition: background-color var(--duration-fast) var(--ease-standard),
    color var(--duration-fast) var(--ease-standard);
}

.menu-top-dropdown-item i {
  font-size: 1.05rem;
  width: 18px;
  text-align: center;
  color: var(--label-secondary);
}

.menu-top-dropdown-text {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.menu-top-dropdown-text span {
  font-size: var(--text-callout);
  font-weight: var(--weight-semibold);
}

.menu-top-dropdown-text .text-xs {
  color: var(--label-secondary);
  font-size: var(--text-caption);
}

.menu-top-dropdown-item:hover {
  background: var(--fill-quaternary);
}

.menu-top-dropdown-item.active {
  background: var(--accent-soft);
  color: var(--accent);
}
.menu-top-dropdown-item.active i,
.menu-top-dropdown-item.active .menu-top-dropdown-text .text-xs {
  color: var(--accent);
}

.online-indicator-top {
  margin: 0;
  padding: var(--space-1) var(--space-3);
}

/* Nav bar superior (móvil) estilo iOS */
.topbar {
  height: 52px;
  padding: 0 var(--space-2);
  background: var(--topbar-bg);
  backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  border-bottom: 1px solid var(--separator);
  position: sticky;
  top: 0;
  z-index: 10;
}
.topbar-title {
  font-size: var(--text-title-2);
  font-weight: var(--weight-semibold);
  color: var(--label-primary);
  text-align: center;
  flex: 1;
}
</style>
